import { render } from "./unavailable-hours-settings.vue?vue&type=template&id=3d930385&ts=true"
import script from "./unavailable-hours-settings.ts?vue&type=script&lang=ts"
export * from "./unavailable-hours-settings.ts?vue&type=script&lang=ts"

import "./unavailable-hours-settings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__